import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr:any;

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {
  nao = new Nanobar();
  first_name: any;
  countryCode: any;
  numChk = false;
  maxYear: any;
  last_name: any;
  number: any;
  email: any;
  is_tax_exempt = false;
  accept_marketing = false;
  address_line1 = '';
  address_line2 = '';
  city: any;
  state: any;
  zip: any;
  area: any;
  apart: any;
  houseNo: any;
  note: any;
  // dob: any;
  success: any;
  restErrorCode: any;
  addingCustomer = false;
  numberChkError: any;
  place: any;
  street: any;
  btnDisable = false;
  error_count: any;
  emailChk: any;
  latitude: any;
  longitude: any;
  clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  private today = new Date();
  selDate: any;
  dob: any;
  selectAddress = false;
   myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'mm/dd/yyyy',
         showTodayBtn: true,
        todayBtnTxt: 'Today',
        showClearDateBtn: false,
        indicateInvalidDate: true,
        editableDateField: false,
        openSelectorOnInputClick: true,
        disableSince: {year: this.today.getFullYear() - 13, month: 1, day: 1},
        // minYear: this.today.getFullYear() - 13,
        // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
        // disableUntil: {year: 0, month: 0, day: 0}
    };
    gender: any = -1;
    showGender: any;
  constructor(private dataService: DataService, private cs: CountryService, private router: Router) {
    this.dataService.pageName = 'add customer';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
    setTimeout(() => {
    this.maxYear = new Date().getFullYear();
    this.maxYear = parseInt(this.maxYear, 10) - 14;
    this.selDate = '01/01/' + this.maxYear;
    this.dob = this.selDate;
    console.log('this.street', this.street);
    console.log('set date prefilled', this.selDate);
    }, 500);
  }
  addCutomerFunction(form: NgForm) {
    // var number =  $('input[name="phone"]').val();
    //     var classf = $('.selected-flag > div').attr('class');
    //     var flag = classf.slice(-2);
    //
    //     // console.log('check number: ', number);
    //     // console.log('check classf: ', classf);
    //     // console.log('check flag: ', flag);
    //
    //     var formattedNumber = intlTelInputUtils.formatNumber(number, flag, intlTelInputUtils.numberFormat.INTERNATIONAL);
    //     $('input[name="phone"]').val(formattedNumber);
    // const value = form.value;
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
     $('.uploadText').css('color', '#3d3e3d');
     $('.c-label input').css('border-color', '#ccc');
     $('.c-label textarea').css('border-color', '#ccc');
    this.addingCustomer = true;
    if ($('#is_tax_exempt').is(':checked')) {
      this.is_tax_exempt = true;
    }
    if ($('#accept_marketing').is(':checked')) {
      this.accept_marketing = true;
    }
    this.city = $('#city').val();
    this.zip = $('#zip').val();
    this.state = $('#state').val();
    this.area = $('#area').val();
    this.apart = $('#apart').val();
    this.houseNo = $('#houseNo').val();
    // this.dob = $('#datepicker').val();
    var formatted_date = this.dob.formatted;
    console.log('this.street', this.street);
    console.log('set date prefilled', this.selDate);
    // this.address_line1 = $('#c-address input').val();
    // console.log('login data');
     if (this.first_name === '' || this.first_name === undefined) {
                  $('#c-fname label').css('color', '#a10a0d');
                  $('#c-fname input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.last_name === '' || this.last_name === undefined) {
                  $('#c-lname label').css('color', '#a10a0d');
                  $('#c-lname input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.number === '' || this.number === undefined || this.numChk === true) {
                  $('#c-phone label').css('color', '#a10a0d');
                  $('#c-phone input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.dob === '' || this.dob === undefined) {
                  $('#c-dob label').css('color', '#a10a0d');
                  $('#c-dob input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.gender === '' || this.gender === -1) {
                  $('#c-gender label').css('color', '#a10a0d');
                  $('#c-gender input').css('border-color', '#a10a0d');
                  this.error_count ++;
}
     
      if (this.address_line1 === '' || this.address_line1 === undefined) {
                  $('#c-address label').css('color', '#a10a0d');
                  $('#c-address input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }

      if (this.city === '' || this.city === undefined) {
                  $('#c-city label').css('color', '#a10a0d');
                  $('#c-city input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.zip === '' || this.zip === undefined) {
                  $('#c-zip label').css('color', '#a10a0d');
                  $('#c-zip input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }

      if (this.error_count > 0) {
        return;
      }
      if (this.email !== '' && this.email !== undefined && this.email !== null) {
      this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.emailChk.test(this.email)) {
                  $('#c-email label').css('color', '#a10a0d');
                  $('#c-email input').css('border-color', '#a10a0d');
                  // this.error_count ++;
        toastr.error('Please Enter a valid email');
        return;
      }
      }
      if (this.latitude === undefined || this.latitude === '' || this.longitude === undefined || this.longitude === '') {
        toastr.error('Please Update the address & select it from Google suggestions for accuracy');
        return;
      }
      console.log('this.street', this.street);
    console.log('set date prefilled', this.selDate);
      var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
      // this.number = '+' + getCode + this.number;
      var number = '+' + getCode + this.number;
      // console.log('number', this.number);
    this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    this.dataService.addCustomer(window.localStorage.getItem('token'),
      this.first_name, this.last_name, number,
      this.email, this.is_tax_exempt, this.accept_marketing,
      this.address_line1, this.street, this.address_line2, this.city,
      this.state, this.zip, this.area, this.apart, this.note, formatted_date, this.latitude, this.longitude, this.houseNo, this.gender,'').subscribe(
      (data) => {
        // console.log('outlet data');
        this.nao.go(100);
        this.restErrorCode = data;
        this.restErrorCode = this.restErrorCode.rest_error_code;
        this.success = data;
        this.success = this.success.success;
        if (this.restErrorCode === 1) {
          toastr.error('Some thing went wrong');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 2) {
          toastr.error('Please login again');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 3) {
          toastr.error('User already exists');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 4) {
          toastr.error('User does not exist');
          this.btnDisable = false;
        }
        if (this.success === true) {
          this.btnDisable = false;
           toastr.success('User added successfully');
          this.router.navigate(['customers']);
        }
        if (this.success === false) {
          this.addingCustomer = false;
          this.btnDisable = false;
        }
      },
      (error) => {
        this.nao.go(100);
        this.addingCustomer = false;
        this.btnDisable = false;
        // console.log('error', error);
      }
    );
  }
   addressDetail() {
    this.street = '';
    $('#state').val('');
    // console.log('chk address detail', this.place);
       for(var i = 0; i < this.placeDetailData.length; i++) {
      for(var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (this.placeDetailData[i].types[j] === 'administrative_area_level_2') {
          // this.city = this.place.address_components[i].long_name;
          // // console.log('city', this.city);
           $('#city').val(this.placeDetailData[i].long_name);
        }
        else if(this.placeDetailData[i].types[j] === 'locality'){
          $('#city').val(this.placeDetailData[i].long_name);
        }
        // if (this.placeDetailData[i].types[j] === 'locality') {
        //   this.city = this.place.address_components[i].long_name;
        //   console.log('city', this.city);
        //    $('#city').val(this.placeDetailData[i].long_name);
        // }
         if (this.placeDetailData[i].types[j] === 'street_number') {
          this.street = this.placeDetailData[i].long_name;
          // console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'route') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          // console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_2') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          // console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_1') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          // console.log('sublocality 1', this.street);
        }
        //   this.street = this.place.name;
        //   // console.log('this.street', this.street);

        if (this.placeDetailData[i].types[j] === 'administrative_area_level_1') {
          $('#state').val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === 'country') {
          // this.area = this.place.address_components[i].long_name;
          $('#area').val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === 'postal_code') {
          // this.zip = this.place.address_components[i].long_name;
          // console.log('postal; code', this.placeDetailData[i].long_name);
          $('#zip').val(this.placeDetailData[i].long_name);
        } else {
            $('#zip').val('');
        }
        }
      }
    }
  // inputAddress1() {
  //   var context = this;
  //   // console.log('inputAddress');
  //
  //   const input = document.getElementById('searchTextField');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     // console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     // console.log('address', context.place);
  //     context.addressDetail();
  //   });
  // }
  restrictUserInput($event) {
    $event.preventDefault();
  }
   countryValidation() {
    var code = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    code = '+' + code;
    var val = $('#phoneValue').val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          // console.log('valid');
          this.numChk = false;
          $('#phoneValue').css('border-color', '#ccc');
        } else {
          // console.log('invalid');
          this.numChk = true;
          $('#phoneValue').css('border-color', '#eb3b3b');
        }
      }
    }
  }
  prevent($event) {
   // console.log('prevent default', $event.keyCode);
   if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
   if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
 }
  capitlizeFirstName() {
 this.first_name = this.first_name.replace(/\b\w/g, function(l) { return l.toUpperCase()});
  }
  capitlizeLastName() {
 this.last_name = this.last_name.replace(/\b\w/g, function(l) { return l.toUpperCase()});
  }
  functionTogetPlace () {
    if ( this.selectAddress === true ){
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
     this.dataService.googleAddress(this.address_line1).subscribe(
      (data) => {
        this.placeSuggestionsData = data;
        this.placeSuggestionsData = this.placeSuggestionsData.predictions;
        // console.log('place google data', this.placeSuggestionsData);
        this.placeDataFound = true;
        if ($('.myDrop').hasClass('open')) {

        } else {
          $('.myDrop').addClass('open');
        }
        // this.addressLoad = false;
        // $('#searchTextField').click();
        // $('#searchTextField').focus();
      },
      (error) => {
      }
    );
     }, 1000);
  }
  functionTogetPlaceDetail (name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
     this.dataService.googleAddressDetail(id).subscribe(
      (data) => {
        // console.log('place google detail data', data);
        this.placeDetailData = data;
        this.selectAddress = true;
        this.placeDetailData = this.placeDetailData.result;
        this.latitude = this.placeDetailData.geometry.location.lat;
        this.longitude = this.placeDetailData.geometry.location.lng;
        // console.log('this.latitude', this.latitude);
        // console.log('this.longitude', this.longitude);
        this.placeDetailData = this.placeDetailData.address_components;
        this.callMap();
        setTimeout(() => {
          this.addressDetail();
          this.addressLoad = false;
        }, 1000);
      },
      (error) => {
      }
    );
     }, 1000);
  }
  callMap(){
    setTimeout(() => {
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng( this.latitude , this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 20,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: 'assets/pin.png', // url
        scaledSize: new google.maps.Size(30, 42), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(16, 41) // anchor
      };
      map = new google.maps.Map(document.getElementById('myMap'), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({'latLng': myLatlng }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log( context.latitude, context.longitude);
            console.log('results', results);
            // context.getDeliveryAddressDetail(results[0]);

          }
        }
      });


      google.maps.event.addListener(marker, 'dragend', function() {
        geocoder.geocode({'latLng': marker.getPosition()}, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              // context.addressNew =  results[0].formatted_address;
              console.log( context.latitude, context.longitude);
              console.log('results', results);
              // this.changeRef.detectChanges();
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });
      });
    }, 10);
  }
  resetAddress(){
    this.address_line1 = '';
    // this.address_line2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.area = '';
    this.apart = '';
    this.houseNo = '';
    this.longitude = '';
    this.latitude = '';
    this.selectAddress = false;
  }
  ngOnInit() {
    // this.functionTogetPlace();
    // this.inputAddress1();
    const context = this;
    $(function() {
      this.maxYear =new Date().getFullYear();
        this.maxYear = parseInt(this.maxYear) - 21;
      $('#datepicker').datepicker({
        format: 'mm/dd/yyyy', // Notice the Extra space at the beginning
        defaultDate:'-10d',
        endDate: new Date('12/31/'+ this.maxYear)
      });
       $('#phone').intlTelInput({
        // autoFormat: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss',
        autoPlaceholder: false,
        preferredCountries: ['GB'],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      var countryCode;
       setTimeout(() => {
        countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        $('#phone').val('+' + countryCode);
       }, 1000);
        $('#phone').change(
                function () {
                     countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
                    $('#phone').val('+' + countryCode);

                }
            );
    });
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
      $('#customer').css('color', '#d77229');
  }

  selectGender(val) {
    if(this.gender != val) {
      // this.showGender = true;
    }
    this.gender = val;
  }

}



// WEBPACK FOOTER //
// ./src/app/add-customer/add-customer.component.ts